import fetch from "./connector";
import { PATH_BASE_URL } from "../../../components/pages/App/constants";
import { getPathDetail } from "../concepts/constants";

export const getPaymentDetail = (interId) =>
  fetch(PATH_BASE_URL, getPathDetail(interId), {
    method: "GET",
  });
